import { Routine } from 'redux-saga-routines';
import { put, call, takeEvery, all } from 'redux-saga/effects';
import { updateProspectStatusRoutine } from '../../routines';
import { updateStatus } from '../../../../services/prospectsService';

function* updateProspectStatus({ payload }: Routine<any>) {
  try {
    yield call(updateStatus, payload);
    yield put(updateProspectStatusRoutine.success(payload.status));
  } catch {
    yield put(updateProspectStatusRoutine.failure());
  }
}

function* watchUpdateProspectStatus() {
  yield takeEvery(updateProspectStatusRoutine.TRIGGER, updateProspectStatus);
}

export default function* prospectSaga() {
  yield all([
    watchUpdateProspectStatus()
  ]);
}
